module.exports = __webpack_public_path__ + "front/img/10.70192771.png";